define('TescoMobile_DynamicBundleOptions/js/price-box-mixin',['jquery', 'underscore', 'TescoMobile_Catalog/js/model/deal'], function ($, _, deal) {
  'use strict';

  return function (widget) {
    $.widget('mage.priceBox', widget, {
      currentOptionKey: null,
      ccaConfig: null,
      priceBoxSelector: 'div.price-box.price-configured_price',
      updatePrice: function (newPrices) {
        $(document).trigger('DynamicOptionsPriceUpdateBefore', [newPrices, this.cache.additionalPriceObject]);
        this._super(newPrices);
        if (this.cache.displayPrices.basePrice) {
          $(document).trigger('DynamicOptionsPriceUpdate', this.cache.displayPrices.basePrice.final);
        }
        $(document).trigger('DynamicOptionsPriceUpdateAfter', this.cache.displayPrices.finalPrice.final);
      }
    });
    return $.mage.priceBox;
  };
});

